<template>
  <v-layout
    column
    :align-center="queryFlag || (align && align == 'center')"
    :align-left="align && align == 'left'"
    :align-right="align && align == 'right'"
  >
    <v-flex xs12 md2>
      <v-switch
        v-if="!queryFlag"
        v-show="!hiddenField(access)"
        v-model="currentValue"
        :id="id"
        :label="label"
        :type="fieldTextType(dataType)"
        :required="requiredField(access)"
        :readonly="readonlyField(access)"
        :rules="rules"
        :color="readonlyField(access) ? 'secondary' : 'primary'"
        @change="handleChange"
      >
        <template v-slot:label>
          <div>
            {{ label }}
            <span v-if="link" @click.stop v-html="link">
            
            </span>
          </div>
        </template>
      </v-switch>
      <v-switch
        v-else
        v-show="!hiddenField(access)"
        :id="id"
        :label="label"
        v-model="currentValue"
        :value="value"
        :type="fieldTextType(dataType)"
        @change="handleChange"
        :required="requiredField(access)"
        :readonly="readonlyField(access)"
        :disabled="readonlyField(access)"
        :outlined="queryFlag"
        :dense="queryFlag"
        :single-line="queryFlag"
        :hide-details="queryFlag"
        :rules="rules"
      />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "CheckField",
  props: [
    "label",
    "value",
    "access",
    "pattern",
    "id",
    "name",
    "align",
    "dataType",
    "rules",
    "queryFlag",
    "coordinates",
    "hint",
    "link",
  ],
  data() {
    return {
      currentValue: this.value,
      defaultValue: this.value,
      autoSource: null,
    };
  },
  methods: {
    handleChange() {
      const data = {
        value: this.currentValue,
        id: this.id,
        autoSource: this.autoSource,
        coordinates: this.coordinates,
      };
      this.$emit("field-change", data);
    },
    setValue(value, autoSource) {
      this.currentValue = value;
      this.autoSource = autoSource;
      this.handleChange();
    },
  },
  updated() {},
  mounted() {},
};
</script>

<style scoped>
</style>